import { useEffect } from 'react';
import { type Editor } from '@meitu/saas-editor-core';
import { TextEditPlugin } from '@meitu/saas-editor-core/es/plugins/text-edit';
import { AlignType, LayerType } from '@meitu/saas-editor-core/es/version-types';
import { CommonToolTracker } from '@/utils/tracker';

export const useHeaderTool = (editor: Editor, firstId: number, recordId?: number) => {
    const onLock = () => {
        CommonToolTracker.lock({ firstId, recordId });
    };

    const onCopy = () => {
        CommonToolTracker.copy({ firstId, recordId });
    };

    const onSort = () => {
        CommonToolTracker.sort({ firstId, recordId });
    };

    const onDelete = () => {
        CommonToolTracker.delete({ firstId, recordId });
    };

    const onCopyBrush = () => {
        CommonToolTracker.copyBrush({ firstId, recordId });
    };

    const onApplyBrush = () => {
        CommonToolTracker.applyBrush({ firstId, recordId });
    };

    const onCopyImageEffect = () => {
        // do track
    };

    useEffect(() => {
        const id = editor.onDelete(() => {
            onDelete();
        }, 9999);
        return () => editor.off(id);
    }, []);

    return {
        onLock,
        onCopy,
        onSort,
        onDelete,
        onCopyBrush,
        onApplyBrush,
        onCopyImageEffect,
    };
};

export const useBaseTool = (editor: Editor, firstId: number, recordId?: number) => {
    const onFlip = async (flip: 'horizontal' | 'vertical') => {
        const layer = editor.active.getPick();
        if (layer && (layer.layerType === LayerType.TEXT_LAYER || layer.layerType === LayerType.VECTOR_LAYER)) {
            const editingLayer = editor.getInstance(TextEditPlugin).getEditingLayer();
            if (editingLayer && editingLayer.id === layer.id) {
                await editor.getInstance(TextEditPlugin).exitEditing();
            }
        }

        CommonToolTracker.flip({ firstId, flip, recordId });
    };

    const onSize = () => {
        CommonToolTracker.size({ firstId, recordId });
    };

    const onRotate = () => {
        CommonToolTracker.rotate({ firstId, recordId });
    };

    const onPosition = () => {
        CommonToolTracker.position({ firstId, recordId });
    };

    const onAlign = (type: AlignType) => {
        CommonToolTracker.align({ firstId, type });
    };

    return {
        onFlip,
        onSize,
        onRotate,
        onPosition,
        onAlign,
    };
};
